import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    messages: [],
    socketStatus: 0, // 0: disconnected, 1: connected
  },
  reducers: {
    setSocketStatus: (state, action) => {
        state.socketStatus = action.payload;
    },
    addNotification: (state, action) => {
      state.messages.push(action.payload);
    },
    clearNotifications: (state) => {
      state.messages = [];
    },
  },
});

export const { setSocketStatus, addNotification, clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
